<template>
    <b-container fluid>
        <app-title :text="`Evaluación de desempeño laboral para ${userName}`" />
        <b-row class="mt-3" v-if="!!qualification">
        <b-col>
        <b-alert variant="success" show>
            <b-row>
                <b-col cols="auto"><app-sub-title :text="`Calificación: ${result}`"></app-sub-title></b-col>
                <b-col><app-sub-title :text="`Desempeño: ${qualification.name}`"></app-sub-title></b-col>
            </b-row>
        </b-alert>
        </b-col>
        </b-row>
        <div>
            <b-card v-for="area in areasAndItems" :key="area.id">
                <b-card-title>{{area.name}}</b-card-title>
                <b-card-body>
                    <b-list-group>
                        <b-list-group-item v-for="item in area.performance_area_items" :key="item.id">
                            <b-row>
                                <b-col>{{item.description}}</b-col>
                                <b-col><app-range-radios min-label="Muy malo" max-label="Muy bueno" @input="q => setAnswer(item.id, q)"></app-range-radios></b-col>
                            </b-row>
                        </b-list-group-item>
                    </b-list-group>
                </b-card-body>
            </b-card>
        </div>
        <div class="mt-5">
            <app-sub-title text="Aspectos a Mejorar"></app-sub-title>
            <app-form-textarea-input rows="5" v-model="improvements"></app-form-textarea-input>
        </div>
        <b-row class="mt-3" v-if="!!qualification">
        <b-col>
        <b-alert variant="success" show>
            <b-row>
                <b-col cols="auto"><app-sub-title :text="`Calificación: ${result}`"></app-sub-title></b-col>
                <b-col><app-sub-title :text="`Desempeño: ${qualification.name}`"></app-sub-title></b-col>
            </b-row>
        </b-alert>
        </b-col>
        </b-row>
        <b-row>
            <b-col cols="4"><b-btn 
            block variant="primary"                         
            :disabled="inProgress"
            @click="saveEvaluation" 
            title="Guardar">
            Guardar</b-btn></b-col>
        </b-row>
    </b-container>
</template>
<script>
import appRangeRadios from '@components/UI/Controls/RangeRadios/RangeRadios'
import { mapGetters, mapMutations } from 'vuex'
export default {
    components: {
        appRangeRadios
    },
    data: () => ({
        areasAndItems: [],
        answers: [],
        improvements: '',
        performanceRanges: [],
        totalItems: 0,
    }),
    computed: {
        ...mapGetters(['currentEvaluation', 'currentEvaluatedUser']),
        userName() {
            return this.currentEvaluatedUser.user?.name ?? ''
        },
        result() {
            return this.answers.reduce((carry, item) => (carry + item.q), 0)
        },
        qualification() {
            const q = this.performanceRanges.find(item => (this.result >= item.min && this.result <= item.max))
            return q
        }
    },
    methods: {
        async loadPerformanceAreas() {
            const { data } = await repo.get('performance-areas')
            if(this.currentEvaluation.administrative){
                this.areasAndItems = data.filter(item => item.classification === 'administrative')
            }else{
                this.areasAndItems = data.filter(item => item.classification === 'operative')
            }
            for (let i = 0; i < this.areasAndItems.length; i++) {
                this.totalItems += this.areasAndItems[i].performance_area_items.length;
            }
        },
        setAnswer(itemId, q) {
            const answers = this.answers.filter(item => item.itemId !== itemId)
            answers.push({
                itemId,
                q
            })
            this.answers = answers
        },
        async loadPerformanceRanges() {
            const {data} = await repo.get('performance-ranges')
            this.performanceRanges = data
        },
        async saveEvaluation(){
            if(this.totalItems === this.answers.length){
                const params = {
                    evaluationId: this.currentEvaluation.id,
                    evaluatedId: this.currentEvaluatedUser.user.id,
                    totalScore: this.result,
                    improvements: this.improvements,
                    range: this.qualification.name
                }
                const {data} = await repo.post('performance-evaluations/store-evaluation', {
                        ...params,
                        answers: this.answers
                    })

                if(data.status){
                    toastr.success(data.msg)
                    this.$router.push({
                        name: 'openPerformanceEvaluation',
                    })
                }else{
                    toastr.error('Ocurrio un error al realizar el registro')
                }
            }else{
                toastr.info('Porfavor califique todos los items')
            }
        }
    },
    created() {
        this.loadPerformanceAreas()
        this.loadPerformanceRanges()
    }
}
</script>
